import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-100 row g-0 mb-2" }
const _hoisted_2 = { class: "col-12 col-lg-4 pe-lg-2 form-group d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "facility-name" }, " Facility Name ", -1 /* HOISTED */)
const _hoisted_4 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-2" }, [
  /*#__PURE__*/_createTextVNode(" Country "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-1" }, [
  /*#__PURE__*/_createTextVNode(" Address Line 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_11 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-2" }, " Address Line 2 ", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_14 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "referral-city" }, [
  /*#__PURE__*/_createTextVNode(" City "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_19 = { for: "referral-state" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_23 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_24 = { for: "referral-zip" }
const _hoisted_25 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_27 = ["value", "disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_30 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "referral-county" }, [
  /*#__PURE__*/_createTextVNode(" County "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_34 = {
  key: 0,
  class: "form-group row ps-0 col-12"
}
const _hoisted_35 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-movein",
  id: "Referral_Date_Of_Birth_Label"
}, " Move-in Date ", -1 /* HOISTED */)
const _hoisted_37 = { class: "input-group date datepickerInput" }
const _hoisted_38 = ["value"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_40 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-moveout",
  id: "Referral_Date_Of_Birth_Label"
}, " Move-out Date ", -1 /* HOISTED */)
const _hoisted_42 = { class: "input-group date datepickerInput" }
const _hoisted_43 = ["value"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_CountryTypeahead = _resolveComponent("CountryTypeahead")!
  const _component_PlacesAutocomplete = _resolveComponent("PlacesAutocomplete")!
  const _component_StateTypeahead = _resolveComponent("StateTypeahead")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_TypeaheadInput, {
        getData: _ctx.getVendorList,
        value: _ctx.selectedFacility,
        onValueChanged: _ctx.updateFacility,
        "init-value": _ctx.selectedFacility,
        placeholder: "Start Typing..."
      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_CountryTypeahead, {
        updateSelectedCountry: _ctx.updateSelectedCountry,
        "prefill-country": _ctx.address.country,
        disabled: _ctx.selectedFacility,
        onBlurredInput: _ctx.v$.referral[_ctx.addressType].country.$touch,
        class: _normalizeClass(`${!_ctx.v$.referral[_ctx.addressType].country.$error ? '' : 'field-invalid'}`)
      }, null, 8 /* PROPS */, ["updateSelectedCountry", "prefill-country", "disabled", "onBlurredInput", "class"]),
      (_ctx.v$.referral[_ctx.addressType].country.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Country is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_PlacesAutocomplete, {
        street: _ctx.address.addressLine1,
        "onUpdate:street": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.addressLine1) = $event)),
        city: _ctx.address.city,
        "onUpdate:city": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address.city) = $event)),
        state: _ctx.address.state,
        "onUpdate:state": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.state) = $event)),
        zip: _ctx.address.zipCode,
        "onUpdate:zip": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.zipCode) = $event)),
        county: _ctx.address.county,
        "onUpdate:county": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.county) = $event)),
        latitude: _ctx.address.latitude,
        "onUpdate:latitude": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address.latitude) = $event)),
        longitude: _ctx.address.longitude,
        "onUpdate:longitude": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.longitude) = $event)),
        disabled: _ctx.selectedFacility,
        "onUpdate:disabled": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFacility) = $event)),
        country: _ctx.autoCompleteCountry,
        "onUpdate:country": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.autoCompleteCountry) = $event)),
        "places-changed-call-back": _ctx.placesChangedCallBack,
        onBlurredInput: _ctx.v$.referral[_ctx.addressType].addressLine1.$touch,
        class: _normalizeClass(`${!_ctx.v$.referral[_ctx.addressType].addressLine1.$error ? '' : 'field-invalid'}`),
        isValidatedAndByPassToggled: _ctx.address.isValidatedAndByPassToggled,
        "onUpdate:isValidatedAndByPassToggled": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.isValidatedAndByPassToggled) = $event))
      }, null, 8 /* PROPS */, ["street", "city", "state", "zip", "county", "latitude", "longitude", "disabled", "country", "places-changed-call-back", "onBlurredInput", "class", "isValidatedAndByPassToggled"]),
      (_ctx.v$.referral[_ctx.addressType].addressLine1.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Address Line 1 is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.address.addressLine2) = $event)),
        placeholder: "Enter Address Line 2"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.address.addressLine2]
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["form-control", `${!_ctx.v$.referral[_ctx.addressType].city.$error ? '' : 'field-invalid'}`]),
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.city) = $event)),
        placeholder: "Enter City",
        disabled: _ctx.selectedFacility,
        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.referral[_ctx.addressType].city.$touch && _ctx.v$.referral[_ctx.addressType].city.$touch(...args)))
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_16), [
        [_vModelText, _ctx.address.city]
      ]),
      (_ctx.v$.referral[_ctx.addressType].city.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "City is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, [
        _createTextVNode(_toDisplayString(_ctx.isUnitedStates ? "State" : "State / Province / Territory") + " ", 1 /* TEXT */),
        _hoisted_20
      ]),
      (_ctx.isUnitedStates)
        ? (_openBlock(), _createBlock(_component_StateTypeahead, {
            key: 0,
            "selected-state": _ctx.selectedState,
            "onUpdate:selected-state": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedState) = $event)),
            "prefill-state": _ctx.address.state,
            "onUpdate:prefill-state": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address.state) = $event)),
            disabled: _ctx.selectedFacility,
            onBlurredInput: _ctx.v$.referral[_ctx.addressType].state.$touch,
            class: _normalizeClass(`${!_ctx.v$.referral[_ctx.addressType].state.$error ? '' : 'field-invalid'}`)
          }, null, 8 /* PROPS */, ["selected-state", "prefill-state", "disabled", "onBlurredInput", "class"]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: _normalizeClass(["form-control", `${!_ctx.v$.referral[_ctx.addressType].state.$error ? '' : 'field-invalid'}`]),
            maxlength: "50",
            type: "text",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.address.state) = $event)),
            placeholder: "Enter State / Province / Territory",
            disabled: _ctx.selectedFacility,
            onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$.referral[_ctx.addressType].state.$touch && _ctx.v$.referral[_ctx.addressType].state.$touch(...args)))
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_21)), [
            [_vModelText, _ctx.address.state]
          ]),
      (_ctx.v$.referral[_ctx.addressType].state.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "State is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("label", _hoisted_24, [
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "A0550"))
          : _createCommentVNode("v-if", true),
        _createTextVNode(" " + _toDisplayString(_ctx.isUnitedStates ? "ZIP" : "Postal Code") + " ", 1 /* TEXT */),
        _hoisted_26
      ]),
      (_ctx.isUnitedStates)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            class: _normalizeClass(["form-control", `${!_ctx.v$.referral[_ctx.addressType].zipCode.$error ? '' : 'field-invalid'}`]),
            maxlength: "10",
            type: "text",
            "number-only": "",
            value: _ctx.formatZipCode(_ctx.address.zipCode),
            onChange: _cache[17] || (_cache[17] = (e) => _ctx.handleZipcodeChange(e)),
            placeholder: "Enter Zip",
            disabled: _ctx.selectedFacility,
            onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.referral[_ctx.addressType].zipCode.$touch && _ctx.v$.referral[_ctx.addressType].zipCode.$touch(...args)))
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_27))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: _normalizeClass(["form-control", `${!_ctx.v$.referral[_ctx.addressType].zipCode.$error ? '' : 'field-invalid'}`]),
            maxlength: "50",
            type: "text",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.address.zipCode) = $event)),
            placeholder: "Enter Postal Code",
            disabled: _ctx.selectedFacility,
            onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.v$.referral[_ctx.addressType].zipCode.$touch && _ctx.v$.referral[_ctx.addressType].zipCode.$touch(...args)))
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_28)), [
            [_vModelText, _ctx.address.zipCode]
          ]),
      (_ctx.v$.referral[_ctx.addressType].zipCode.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "ZIP is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["form-control", `${!_ctx.v$.referral[_ctx.addressType].county.$error ? '' : 'field-invalid'}`]),
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.address.county) = $event)),
        placeholder: "Enter County",
        disabled: _ctx.selectedFacility,
        onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.v$.referral[_ctx.addressType].county.$touch && _ctx.v$.referral[_ctx.addressType].county.$touch(...args)))
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_32), [
        [_vModelText, _ctx.address.county]
      ]),
      (_ctx.v$.referral[_ctx.addressType].county.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "County is required."))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.showMoveDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_DatePicker, {
              options: _ctx.datePickerOptions,
              getDate: _ctx.handleDateChange
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("input", {
                    name: "moveInDate",
                    id: "Movein_Date",
                    type: "text",
                    class: "form-control",
                    placeholder: "MM/DD/YYYY",
                    value: _ctx.formatDateInput(_ctx.address.moveInDate),
                    autocomplete: "off",
                    "date-format-only": ""
                  }, null, 8 /* PROPS */, _hoisted_38),
                  _hoisted_39
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["options", "getDate"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("input", {
                    name: "moveOutDate",
                    id: "Moveout_Date",
                    type: "text",
                    class: "form-control",
                    placeholder: "MM/DD/YYYY",
                    value: _ctx.formatDateInput(_ctx.address.moveOutDate),
                    autocomplete: "off",
                    "date-format-only": ""
                  }, null, 8 /* PROPS */, _hoisted_43),
                  _hoisted_44
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}